import { usePublicSiteData } from "./PublicSiteContext";
import PublicSectionTitle from "./PublicSectionTitle";
import PublicServiceCard from "./PublicServiceCard";
import { useStage } from "./StagedImageLoading";

const PublicFeaturedServices = () => {
  const website = usePublicSiteData();
  const services = website?.services ?? [];
  const serviceImageCount = services
    .slice(0, 3)
    .filter((s) => s.imageUrl).length;
  useStage("services", serviceImageCount);

  return (
    <section className="psite-section">
      <div className="psite-section__inner">
        <PublicSectionTitle
          title="Featured Services"
          description="Setting the benchmark for aesthetic excellence."
        />
        {services.length > 0 ? (
          <div className="psite-services">
            {services.slice(0, 3).map((service) => (
              <PublicServiceCard key={service.id} service={service} />
            ))}
          </div>
        ) : (
          <p className="psite-section__empty">
            Services will appear here once published.
          </p>
        )}
      </div>
    </section>
  );
};

export default PublicFeaturedServices;